import type { Language } from '@seek/melways-sites';
import type { SalaryRangeByRole } from '../../companyProfiles/pages/salaries/salariesTabModel';

export const sortSalaryRangeByRoles = ({
  salaryRangeByRoles,
  language,
}: {
  language: Language;
  salaryRangeByRoles: SalaryRangeByRole[];
}) => {
  if (language === 'en') return salaryRangeByRoles;

  // Sort non-English languages by role title in the specified language locale
  return salaryRangeByRoles.sort((a, b) =>
    a.roleTitle.localeCompare(b.roleTitle, language),
  );
};
